import React from "react";
import PropTypes from "prop-types";
import { useOverflowScrollbar } from "../hooks/useOverflowScrollbar";

export default function StudentSidebarNavScroller({ children }) {
  const {
    scrollRef,
    trackRef,
    metrics,
    handleThumbPointerDown,
    handleTrackPointerDown,
  } = useOverflowScrollbar();
  const child = React.Children.only(children);

  return (
    <div className="side-sidebar-nav-scroll" data-testid="student-sidebar-nav-scroll">
      {React.cloneElement(child, { ref: scrollRef })}
      <div
        ref={trackRef}
        className={`side-sidebar-scrollbar${metrics.canScroll ? " is-visible" : ""}`}
        data-testid="student-sidebar-scrollbar"
        aria-hidden="true"
        onPointerDown={handleTrackPointerDown}
      >
        <div
          className="side-sidebar-scrollbar__thumb"
          data-testid="student-sidebar-scrollbar-thumb"
          style={{
            height: `${metrics.thumbHeight}px`,
            transform: `translateY(${metrics.thumbOffset}px)`,
          }}
          onPointerDown={handleThumbPointerDown}
        />
      </div>
    </div>
  );
}

StudentSidebarNavScroller.propTypes = {
  children: PropTypes.element.isRequired,
};
